// src/locales/en/userRoles.js
export const userRoles = {
    createNewRole: "Create New User Role",
    definePermissions: "Define permissions and access levels for team members",
    basicInformation: "Basic Information",
    provideBasicDetails: "Provide basic details about the role",
    roleName: "Role Name",
    roleNamePlaceholder: "Enter role name (e.g., Manager, Staff)",
    description: "Description",
    descriptionPlaceholder: "Optional description about this role and its responsibilities...",
    descriptionHint: "Provide a brief description to help others understand this role's purpose",
    permissions: "Permissions",
    selectPermissions: "Select which actions this role can perform",
    selected: "Selected",
    total: "Total",
    loadingPermissions: "Loading Permissions...",
    loadingPermissionsDesc: "Please wait while we fetch the available permissions.",
    roleNameRequired: "Role name is required",
    roleNameMinLength: "Role name must be at least 2 characters",
    selectAtLeastOne: "Please select at least one permission",
    roleCreatedSuccess: "Role \"{{roleName}}\" created successfully!",
    failedToCreate: "Failed to create role. Please try again.",
    failedToLoadPermissions: "Failed to load permissions. Please try again.",
    backToRoles: "Back to Roles",
    createRole: "Create Role",
    manageUserRoles: "Manage user roles and permissions for your team",
    loadingRoles: "Loading Roles...",
    loadingRolesDesc: "Please wait while we fetch the user roles.",
    searchRoles: "Search roles by name or description...",
    searchResults: "{{count}} of {{total}} roles",
    totalRoles: "{{count}} roles",
    noSearchResults: "No roles found",
    noSearchResultsDesc: "Try adjusting your search terms or clear the search to see all roles.",
    clearSearch: "Clear Search",
    noRoles: "No user roles yet",
    noRolesDesc: "Create your first user role to start managing team permissions.",
    createFirstRole: "Create First Role",
    noDescription: "No description provided",
    moreActions: "More actions",
    confirmDelete: "Are you sure you want to delete the role '{{roleName}}'? This action cannot be undone.",
    roleDeletedSuccess: "Role '{{roleName}}' has been deleted successfully.",
    failedToDelete: "Failed to delete role. Please try again.",
    retry: "Retry",
    editRole: "Edit User Role",
    updatePermissions: "Update permissions and access levels for this role",
    updateBasicDetails: "Update basic details about the role",
    loadingRole: "Loading Role...",
    loadingRoleDesc: "Please wait while we fetch the role data.",
    roleNotFound: "Role not found. It may have been deleted.",
    failedToLoadRole: "Failed to load role data. Please try again.",
    noChangesToSave: "No changes have been made to save.",
    roleUpdatedSuccess: "Role '{{roleName}}' updated successfully!",
    failedToUpdate: "Failed to update role. Please try again.",
    confirmDiscardChanges: "You have unsaved changes. Are you sure you want to leave without saving?",
    updateRole: "Update Role",
    noChanges: "No Changes",
    unsavedChanges: "Unsaved Changes",
    discardChanges: "Discard Changes",
    systemRole: "System Role",
    confirmDuplicate: "Create a copy of '{{roleName}}'?",
    roleDuplicatedSuccess: "Role '{{roleName}}' duplicated successfully!",
    failedToDuplicate: "Failed to duplicate role. Please try again.",
    cannotDeleteRoleWithUsers: "Cannot delete role. Users are assigned to this role."
}